module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro-text_body"
  }, _vm._l((_vm.introText), function(block) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(block)
      }
    })
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text_lockup "
  }, [_c('label', {
    staticClass: "block-heading-font-style"
  }, [_vm._v("our platform")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2256abc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IntroText.vue
// module id = 462
// module chunks = 0